if (!customElements.get('product-modal')) {
  customElements.define('product-modal', class ProductModal extends ModalDialog {
    constructor() {
      super();
    }

    hide() {
      super.hide();
      window.pauseAllMedia();
    }

    show(opener) {
  const mediaId = opener.getAttribute('data-media-id');
  const targetMedia = document.querySelector(`[data-media-id="${mediaId}"]`);
  if (targetMedia && (targetMedia.getAttribute('data-media-type') === 'video' || targetMedia.getAttribute('data-media-type') === 'external_video')) {
    return;
  }
  super.show(opener);
  this.showActiveMedia();
}


  showActiveMedia() {
  const fullMediaId = this.openedBy.getAttribute("data-media-id");
  const mediaId = fullMediaId ? fullMediaId.split('-').pop() : null;

  this.querySelectorAll(`[data-media-id]:not([data-media-id="${mediaId}"])`).forEach((element) => {
    element.classList.remove('is-active');
  })
  
  const activeMedia = this.querySelector(`[data-media-id="${mediaId}"]`);
  
  if (!activeMedia) return;
  
  if (activeMedia.nodeName === 'DEFERRED-MEDIA') {
    super.hide();
    return;
  }

  const activeMediaTemplate = activeMedia.querySelector('template');
  const activeMediaContent = activeMediaTemplate ? activeMediaTemplate.content : null;
  activeMedia.classList.add('is-active');
  activeMedia.scrollIntoView();

  const container = this.querySelector('[role="document"]');
  container.scrollLeft = (activeMedia.width - container.clientWidth) / 2;

  if (activeMedia.nodeName == 'DEFERRED-MEDIA' && activeMediaContent && activeMediaContent.querySelector('.js-youtube'))
    activeMedia.loadContent();
}



  });
}
